import { useState } from 'react';
import {
  Stack, Group, Title, Text, Button, Paper, Alert, Checkbox, Image, Box,
} from '@mantine/core';
import { api } from '../../wheel-api/client';
import { TecladoNumerico } from './TecladoNumerico';
import { UI } from '../../theme/kioskTheme';

export function EncuentroScreen() {
  const [numero, setNumero] = useState('');
  const [par, setPar] = useState(null);
  const [presentes, setPresentes] = useState(false);
  const [resultado, setResultado] = useState(null);
  const [error, setError] = useState(null);
  const [cargando, setCargando] = useState(false);

  const volver = () => {
    setNumero(''); setPar(null); setPresentes(false);
    setResultado(null); setError(null);
  };

  async function buscar() {
    setCargando(true); setError(null);
    try {
      setPar(await api.gemelosVerEncuentro(Number(numero)));
    } catch (err) {
      setError(err.data?.message || 'No pudimos buscar ese número.');
    } finally { setCargando(false); }
  }

  async function confirmar() {
    setCargando(true); setError(null);
    try {
      setResultado(await api.gemelosCerrarEncuentro(Number(numero), { presentes }));
    } catch (err) {
      setError(err.data?.message || 'No pudimos confirmar el encuentro.');
    } finally { setCargando(false); }
  }

  // ---- Resultado ---------------------------------------------------------
  if (resultado) {
    return (
      <Stack align="center" justify="center" style={{ flex: 1 }} gap="lg" px="8%">
        <Title order={1} ta="center" c="forvet.7" style={{ fontSize: 'clamp(26px, 4.6vh, 46px)' }}>
          {resultado.yaEstaba ? 'ESTE PAR YA ESTABA CERRADO' : '¡ENCUENTRO CONFIRMADO!'}
        </Title>
        <Text size="xl" ta="center" c="forvet.6" maw={700}>{resultado.mensaje}</Text>

        <Group gap="lg" justify="center">
          {resultado.codigos.map(c => (
            <Paper key={c} withBorder radius="lg" p="lg"
                   style={{ borderWidth: 3, borderColor: UI.accion, minWidth: 260 }}>
              <Text ta="center" c="forvet.6" size="md">Beca 50%</Text>
              <Text ta="center" fw={900} ff="monospace"
                    style={{ fontSize: 'clamp(28px, 5vh, 44px)', letterSpacing: 3 }}>
                {c}
              </Text>
            </Paper>
          ))}
        </Group>

        <Alert color="blue" radius="md" style={{ maxWidth: 640 }}>
          <Text fw={700} size="lg">Sacales la foto de los dos</Text>
          <Text size="md">
            Imprimila y pegala en el muro con el número {String(numero).padStart(3, '0')}.
          </Text>
        </Alert>

        <Button h={72} w={360} onClick={volver}>OTRO ENCUENTRO</Button>
      </Stack>
    );
  }

  // ---- Verificación ------------------------------------------------------
  if (par) {
    return (
      <Stack style={{ flex: 1, minHeight: 0 }} px="6%" gap="md" justify="center">
        <Title order={2} ta="center" c="forvet.7">
          ¡SE ENCONTRARON! · Nº {String(par.numero).padStart(3, '0')}
        </Title>
        <Text ta="center" c="forvet.6" size="lg">
          Verificá que las personas que tenés enfrente son estas dos
        </Text>

        <Group justify="center" gap="xl" align="stretch">
          {par.personas.map(p => (
            <Paper key={p.tagId} withBorder radius="lg" p="md"
                   style={{ width: 260, borderWidth: 2, borderColor: UI.borde }}>
              <Box style={{
                height: 220, borderRadius: 10, overflow: 'hidden',
                background: UI.borde, display: 'grid', placeItems: 'center',
              }}>
                {p.fotoUrl
                  ? <Image src={p.fotoUrl} alt={p.nombre} h={220} w="100%" fit="cover" />
                  : <Text c="forvet.6" ta="center" px="sm" size="sm">
                      {p.sinFoto ? 'No autorizó su imagen' : 'Sin foto todavía'}
                    </Text>}
              </Box>
              <Text ta="center" fw={800} size="xl" mt="sm" c="forvet.8">{p.nombre}</Text>
              <Text ta="center" c="forvet.6" size="sm">
                mitad {p.half}{p.areas?.length ? ` · ${p.areas.join(', ')}` : ''}
              </Text>
            </Paper>
          ))}
        </Group>

        {par.yaCerrado && (
          <Alert color="orange" radius="md">
            Este par ya fue confirmado. Volver a confirmar no genera premios nuevos.
          </Alert>
        )}

        <Checkbox
          size="lg" checked={presentes}
          onChange={e => setPresentes(e.currentTarget.checked)}
          label="Están las dos personas presentes"
          styles={{ label: { fontSize: 20, fontWeight: 600 } }}
        />

        {error && <Alert color="red" radius="md">{error}</Alert>}

        <Group grow>
          <Button variant="outline" h={72} onClick={volver}>CANCELAR</Button>
          <Button h={72} disabled={!presentes} loading={cargando} onClick={confirmar}>
            CONFIRMAR Y ENTREGAR PREMIOS
          </Button>
        </Group>
      </Stack>
    );
  }

  // ---- Buscar el número --------------------------------------------------
  return (
    <Stack align="center" justify="center" style={{ flex: 1 }} gap="lg" px="10%">
      <Title order={2} ta="center" c="forvet.7" style={{ fontSize: 'clamp(22px, 3.6vh, 38px)' }}>
        SE ENCONTRARON
      </Title>
      <Text size="lg" c="forvet.6">Número de la caravana</Text>

      <Paper withBorder radius="lg" p="lg" style={{ width: 320 }}>
        <TecladoNumerico value={numero} onChange={v => { setNumero(v); setError(null); }} />
      </Paper>

      {error && <Alert color="red" radius="md" style={{ maxWidth: 520 }}>{error}</Alert>}

      <Button h={72} w={320} disabled={!numero} loading={cargando} onClick={buscar}>
        BUSCAR
      </Button>
    </Stack>
  );
}
